import axiosInstance from "@/lib/axios";

import { OneIdAuthRequest, OneIdAuthResponse } from "../types/OneIdAuth";

export const oneIdAuthAPI = {
  authenticate: async (
    request: OneIdAuthRequest,
  ): Promise<OneIdAuthResponse> => {
    const response = await axiosInstance.post<OneIdAuthResponse>(
      "/users/auth/one-id/",
      {
        code: request.code,
      },
    );
    return response.data;
  },
};
